var React = require('react');

function SProtein (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.367 0a1.367 1.367 0 000 2.733h7.288v16.628a1.367 1.367 0 002.733 0V2.733h7.29a1.367 1.367 0 000-2.733H1.366z","fill":"#FA0067"}));
}

SProtein.defaultProps = {"fill":"none","viewBox":"0 0 21 21"};

module.exports = SProtein;

SProtein.default = SProtein;
